<ng-content select="app-data-filters"></ng-content>

<div class="table-responsive">
    <table class="table table-striped text-left">
        <thead>
        <tr>
            <th *ngIf="showBluechatColumns">
                <div class="checkbox">
                    <label>
                        <input type="checkbox" (change)="selectAll($event.currentTarget.checked)">
                        <i class="fa checkbox-icon"></i>
                    </label>
                </div>
            </th>
            <th [i18n]="'user-table.email'"></th>
            <th *ngIf="showCarrier" [i18n]="'user-table.carrier'"></th>
            <th *ngIf="showSubcontractor" [i18n]="'user-table.subcarrier'"></th>
            <th *ngIf="showRegions"><div class="text-center" [i18n]="'user-table.regions'"></div></th>
            <th *ngIf="showPlants"><div [i18n]="'user-table.plants'"></div></th>
            <th *ngIf="showStatus"><div class="text-center" [i18n]="'user-table.status'"></div></th>
            <th *ngIf="showBluechatColumns"><div class="text-center" [i18n]="'bluechat.title'"></div></th>
            <th *ngIf="showDelete"><div class="text-right" [i18n]="'user-table.delete'"></div></th>
            <th *ngIf="showActionsColumn">
                <div class="text-right" [i18n]="'user-table.actions'"></div>
            </th>
            <th *ngIf="showEdit">
                <div class="text-right" [i18n]="'user-table.actions'"></div>
            </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let u of pagedUsers?.results">
            <td *ngIf="showBluechatColumns">
                <div class="checkbox" *ngIf="!u.bluechatId">
                    <label>
                        <input type="checkbox" [(ngModel)]="u.selected" (change)="onUserCheckChange(u, $event.currentTarget.checked)">
                        <i class="fa checkbox-icon"></i>
                    </label>
                </div>
            </td>
            <td>{{u.email}}</td>
            <td *ngIf="showRegions">
                <div class="region-name-list">
                    <span class="region-name" *ngFor="let region of u.regions">
                        <a class="cmaweb-link" [href]="link.goToRegion(region.name)" target="_blank">{{region.name}}</a>
                    </span>
                </div>
            </td>
            <td *ngIf="showPlants">
                <div class="plant-name-container">
                    <span class="plant-name" *ngFor="let plant of u.plants">
                        <a class="cmaweb-link" [href]="link.goToLocationGlid(plant.glid)" target="_blank">{{plant.glid}}</a>
                    </span>
                </div>
            </td>
            <td *ngIf="showCarrier">
                <ng-container *ngIf="u.carrier">
                    <a class="cmaweb-link" [href]="link.goToDrivers(u.carrier.id, selfCarrierMode)" target="_blank" *ngIf="subcontractorMode">{{u.carrier.name}}</a>
                    <a class="cmaweb-link" [href]="link.goToCarrierCode(u.carrier.code, selfCarrierMode)" target="_blank" *ngIf="!subcontractorMode">{{u.carrier.name}}</a>
                </ng-container>
            </td>
            <td *ngIf="showSubcontractor">
                <ng-container *ngIf="u.subcontractor">
                    <a class="cmaweb-link" *ngIf="!subcontractorMode" [href]="link.goToSubcontractorDrivers(u.carrier.id, u.subcontractor.id, selfCarrierMode)" target="_blank">{{u.subcontractor.name}}</a>
                    <a class="cmaweb-link" *ngIf="subcontractorMode" [href]="link.goToSubcontractor(u.carrier.id, u.subcontractor.name, selfCarrierMode)" target="_blank">{{u.subcontractor.name}}</a>
                </ng-container>
            </td>
            <td *ngIf="showStatus">
                <div class="text-center">
                    <span class="fa" [ngClass]="{ 'fa-unlock text-success': !u.blocked, 'fa-lock text-danger': u.blocked }"
                            [i18n]="[{target: 'attribute:title', key: u.blocked ? 'user-table.blocked' : 'user-table.active'}]"></span>
                </div>
            </td>
            <td *ngIf="showBluechatColumns" class="force-text-center">
                <button class="btn btn-i btn-outline-secondary btn-sm"
                        (click)="openEnableBluchatForUserModal(u)"
                        *ngIf="!u.bluechatEnabled()"
                        [disabled]="!bluechatEnabled">
                    <span><i class="fas fa-comment-alt"></i><span [i18n]="'bluechat.activate'"></span></span>
                </button>
                <div class="status status-activate" *ngIf="u.bluechatEnabled()">
                    <span><i class="fa fa-check"></i><span [i18n]="'bluechat.activated'"></span></span>
                </div>
            </td>
            <td *ngIf="showDelete">
                <div class="text-right">
                    <button class="btn btn-outline-secondary btn-sm pull-right" (click)="deleteUser(u.id)">
                        <i style="color: red" class="fa fa-trash"></i>
                    </button>
                </div>
            </td>
            <td *ngIf="showEdit" class="force-text-center">
                <div class="action-buttons">
                    <button class="btn btn-outline-secondary btn-sm m-l-sm btn-i" (click)="editUser(u.id)">
                        <i class="fa fa-edit"></i>
                        <span [i18n]="'user-table.edit'"></span>
                    </button>
                </div>
            </td>
            <td *ngIf="showActionsColumn" class="actions-column force-text-center">
                <div class="loadDetailsColumn-content">
                    <div [ngTemplateOutlet]="actionsColumn" [ngTemplateOutletContext]="{ user: u }"></div>
                </div>
            </td>
        </tr>
        <tr *ngIf="pagedUsers?.count === 0">
            <td [attr.colspan]="100" class="force-text-center">
                <em [i18n]="'user-table.no-user'"></em>
            </td>
        </tr>
        </tbody>
    </table>

    <div class="table-footer">
        <span class="inner-space-left-10">
            <app-ajax-pagination [(page)]="page" [pageSize]="pageSize" [lastPage]="lastPage"
                                 (pageChange)="getPage($event, pageSize)"></app-ajax-pagination>
        </span>
        <span class="inner-space-right-10 footer-control">
            <select [(ngModel)]="pageSize" class="form-control size-select" (change)="getPage(page, pageSize)">
                <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{size}}</option>
            </select>
            <span class="entries-count" [i18n]="[{target: 'innerHTML', key: 'data-table.count', params: { count: pagedUsers?.totalCount }}]"></span>
        </span>

    </div>
</div>

<ng-template #bluechatActivationMultiUsersModal>
    <span [i18n]="'bluechat.modal.users.list.label'"></span>
</ng-template>


<ng-template #bluechatActivationSingleUserModal let-user="user">
    <div class="m-b-md">
        <span [i18n]="'bluechat.modal.users.content-first'"></span> <strong class="text-primary">{{user.email}}</strong>
    </div>

    <div class="alert alert-info">
        <i class="fa fa-info-circle m-r-xs"></i>
        <span><span [i18n]="'bluechat.modal.users.content-second'"></span></span>
    </div>

    <div class="row">
        <div class="col-xs-12 m-b-md text-primary">
            <span [i18n]="'bluechat.modal.users.content-third'"></span>
        </div>
        <div class="col-xs-12 row m-b-md">
            <div class="col-xs-3"><span [i18n]="'bluechat.modal.users.firstname-label'"></span> :</div>
            <div class="col-xs-9"><input type="text" class="form-control" [(ngModel)]="bluechatActivationModalFirstname"></div>
        </div>
        <div class="col-xs-12 row m-b-md">
            <div class="col-xs-3"><span [i18n]="'bluechat.modal.users.lastname-label'"></span> :</div>
            <div class="col-xs-9"><input type="text" class="form-control" [(ngModel)]="bluechatActivationModalLastname"></div>
        </div>
    </div>
    <span [i18n]="'bluechat.modal.users.content-fourth'"></span>
</ng-template>
